import './VehicleInfo.css'

interface VehicleInfoProps {
  year?: number
  make?: string
  model?: string
  vin: string
  date: string
  time: string
}

export default function VehicleInfo({
  year,
  make,
  model,
  vin,
  date,
  time,
}: VehicleInfoProps) {
  // Формируем заголовок с учетом опциональных полей
  const titleParts: string[] = []
  if (year) titleParts.push(year.toString())
  if (make) titleParts.push(make)
  if (model) titleParts.push(model)
  
  const title = titleParts.length > 0 ? titleParts.join(', ') : 'Vehicle Information'

  return (
    <div className="vehicle-info">
      <h2 className="vehicle-info__title">{title}</h2>
      <p className="vehicle-info__vin">VIN: {vin}</p>
      <p className="vehicle-info__datetime">
        {date}, {time}
      </p>
    </div>
  )
}
